import * as yup from "yup";

let CalculateTaxSchema = yup.object().shape({
  amount: yup.number().required("Amount is required"),
  inclusive: yup.number().required("Select an option"),
});

export default CalculateTaxSchema;
